export const EMPLOYMENT_STATUS = 'EMPLOYMENT_STATUS'

export const storeEmploymentStatus = (status: string) => {
  localStorage.setItem(EMPLOYMENT_STATUS, status)
}

export const getEmploymentStatus = () => localStorage.getItem(EMPLOYMENT_STATUS)
